export const FORMATEN = {
  viking_980460: {
    naam: "Viking 980460 — 24/vel (70 × 36 mm)",
    layout: { kolommen: 3, rijen: 8, breedte_mm: 70, hoogte_mm: 36, marge_links_mm: 0, marge_boven_mm: 4.5, tussen_h_mm: 0, tussen_v_mm: 0 },
  },
  vel48: {
    naam: "48/vel (45,7 × 21,2 mm)",
    layout: { kolommen: 4, rijen: 12, breedte_mm: 45.7, hoogte_mm: 21.2, marge_links_mm: 8, marge_boven_mm: 13, tussen_h_mm: 2.5, tussen_v_mm: 0 },
  },
  eigen: { naam: "Eigen formaat", layout: null },
};
export const MM_VELDEN = [
  ["kolommen", "Kolommen"], ["rijen", "Rijen"], ["breedte_mm", "Breedte (mm)"],
  ["hoogte_mm", "Hoogte (mm)"], ["marge_links_mm", "Marge links (mm)"],
  ["marge_boven_mm", "Marge boven (mm)"], ["tussen_h_mm", "Tussenruimte ↔ (mm)"],
  ["tussen_v_mm", "Tussenruimte ↕ (mm)"],
];
export const DEFAULT_SETTINGS = { formaat: "viking_980460", layout: FORMATEN.viking_980460.layout, toon_maand: true, toon_uren: true };
export const settingValues = (value) => ({
  formaat: value.formaat,
  layout: Object.fromEntries(MM_VELDEN.map(([key]) => {
    const text = String(value.layout[key] ?? "").trim();
    return [key, text ? Number(text.replace(",", ".")) : NaN];
  })),
  toon_maand: value.toon_maand, toon_uren: value.toon_uren,
});
export const layoutError = (settings) => {
  const { layout: l } = settingValues(settings);
  for (const [key, label] of MM_VELDEN) {
    const count = key === "kolommen" || key === "rijen";
    const size = key === "breedte_mm" || key === "hoogte_mm";
    const max = key === "kolommen" ? 20 : key === "rijen" ? 50 : key.includes("breedte") || key.includes("links") || key === "tussen_h_mm" ? 210 : 297;
    if (!Number.isFinite(l[key]) || l[key] < (count ? 1 : size ? 10 : 0) || l[key] > max || (count && !Number.isInteger(l[key]))) return `Vul een geldige waarde in bij ${label.toLowerCase()}.`;
  }
  if (l.marge_links_mm + l.kolommen * l.breedte_mm + (l.kolommen - 1) * l.tussen_h_mm > 210.05) return "De indeling is breder dan een A4-vel (210 mm).";
  if (l.marge_boven_mm + l.rijen * l.hoogte_mm + (l.rijen - 1) * l.tussen_v_mm > 297.05) return "De indeling is hoger dan een A4-vel (297 mm).";
  return "";
};
export const settingsError = (error) => {
  const detail = error.response?.data?.detail;
  return typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((item) => item.msg).join(" · ") : "Instellingen konden niet worden verwerkt. Probeer het opnieuw.";
};
export const legacySettings = () => {
  try {
    const layout = JSON.parse(localStorage.getItem("etiket_layout"));
    if (!layout) return null;
    const draft = { ...DEFAULT_SETTINGS, formaat: "eigen", layout };
    return layoutError(draft) ? null : settingValues(draft);
  } catch { return null; }
};